export default "__VITE_ASSET__8a8b2939__"